import type {
  FaceCheckAllResponse,
  FaceStatusEntry,
  FaceStatusListResponse,
  MyFaceStatusResponse,
} from '@hub-wifi/shared'
import { apiRequest } from './client'

/** `GET /api/my/face-status` — did the door reader accept my face photo? */
export function getMyFaceStatus(token: string) {
  return apiRequest<MyFaceStatusResponse>('/api/my/face-status', { token })
}

/** Admin: `GET /api/access/face-status`. */
export function listFaceStatus(token: string) {
  return apiRequest<FaceStatusListResponse>('/api/access/face-status', { token })
}

/** Admin: re-send one coworker's photo to the reader; returns the new status row. */
export function retryFaceEnrollment(token: string, coworkerId: string) {
  return apiRequest<FaceStatusEntry>(`/api/access/face-status/${coworkerId}/retry`, {
    method: 'POST',
    token,
  })
}

/** Admin: re-send one bounded batch of photos (backfill); pass `nextCursor` back until null. */
export function checkAllFaces(token: string, cursor?: number) {
  return apiRequest<FaceCheckAllResponse>('/api/access/face-status/check-all', {
    method: 'POST',
    body: { cursor },
    token,
  })
}

/** `PUT /api/my/face-photo` — replace my own face photo; the response is the
 * door reader's answer right away (same shape as `getMyFaceStatus`). */
export function putMyFacePhoto(token: string, photoBase64: string) {
  return apiRequest<MyFaceStatusResponse>('/api/my/face-photo', {
    method: 'PUT',
    body: { photoBase64, consent: true },
    token,
  })
}
